import React from "react";
import { useDispatch } from "react-redux";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import AppStoreDetails from "web/react/components/app-store-details/app-store-details";
import { CustomerCaptureOverlay } from "web/react/components/customer-capture-overlay/customer-capture-overlay";
import SearchAndCompare from "web/react/components/search-and-compare/search-and-compare";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import withReduxProvider from "web/react/redux-provider";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import { gettext } from "web/script/modules/django-i18n";
import browser from "web/script/utils/browser";
import styles from "./app-download-promo.module.css";
import backgroundVideo from "./background.mp4";

interface AppDownloadPromoProps {
    branchLink: string;
}

function AppDownloadPromo({ branchLink }: AppDownloadPromoProps): JSX.Element {
    const dispatch = useDispatch();
    const { isMobileViewport, isTabletViewport } = useDomViewport();

    let title = gettext("app_landing.title");

    function scanQrCode(e): void {
        e.preventDefault();
        dispatch(
            openCustomerCaptureOverlay({
                captureType: "qr_code",
                branchLink: branchLink,
            })
        );
    }

    return (
        <div className={styles.appDownloadPromoContainer}>
            <video playsInline autoPlay muted loop className={styles.backgroundVideo}>
                <source src={backgroundVideo} type="video/mp4" />
            </video>
            <div className={styles.backgroundImage} />
            <div className={styles.contentContainer}>
                <div className={styles.toAppCallToAction}>
                    <h1>{title}</h1>
                    {!browser.android && <AppStoreDetails />}
                    {isMobileViewport || isTabletViewport ? (
                        <>
                            <AppDownloadBadge
                                color="black"
                                branchLink={branchLink}
                                eventLabel="desktop_web_to_app_download"
                                isButton={true}
                                buttonText={gettext("app_landing.download_free.button")}
                            />

                            <a href="#" onClick={scanQrCode} className={styles.scanQrLink}>
                                {gettext("app_landing.scan_qr.link")}
                                <SVGIcon name="qr-icon" />
                            </a>
                        </>
                    ) : (
                        <div>
                            <div className={styles.badgeHolder}>
                                <AppDownloadBadge
                                    color="black"
                                    branchLink={branchLink}
                                    eventLabel="desktop_web_to_app_download"
                                    isButton={false}
                                />
                                <AppDownloadBadge
                                    color="black"
                                    branchLink={branchLink}
                                    eventLabel="desktop_web_to_app_download"
                                    isButton={false}
                                    buttonText={gettext("app_landing.download_free.button")}
                                    badgeType="android"
                                />
                            </div>
                            <a href="#" onClick={scanQrCode} className={styles.scanQrLink}>
                                {gettext("app_landing.scan_qr.link")}
                                <SVGIcon name="qr-icon" />
                            </a>
                        </div>
                    )}
                </div>
                <div className={styles.toAppAnimation}>
                    <SearchAndCompare branchLink={branchLink} />
                </div>
                <div className={styles.downloadAppMobilePanel}>
                    <AppDownloadBadge
                        color="black"
                        eventLabel="mobile_web_to_app_download"
                        isButton={true}
                        buttonText={gettext("app_landing.download_free.button")}
                        branchLink={branchLink}
                    />
                </div>
            </div>
            <CustomerCaptureOverlay />
        </div>
    );
}

export default withReduxProvider(AppDownloadPromo);
